import React from 'react';
import { CardTitle, Link } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import { showAboveSmBreakpointIf, quoteCardTitleStyles } from '../../constants/responsiveClassNames';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesHeader = ({ hideActionLink }) => {
  const {
    loading,
    error,
    isMobile
  } = useQuoteContext();

  if (loading || error) return null;

  const viewAllQuotesClick = () => {
    triggerAnalyticsCustomEvent('quotes.stash-click', {
      component: 'view all'
    });
  };

  return (
    <div className="sui-flex sui-flex-row sui-mb-3 sui-justify-between sui-items-center">
      <div className="sui-flex sui-flex-row sui-gap-3 sui-items-center">
        <Orders />
        <h3 className={quoteCardTitleStyles}>Quotes</h3>
      </div>
      {(!isMobile && !hideActionLink) && (
        <Link onClick={viewAllQuotesClick} href="/quote/list">View All Quotes</Link>
      )}
    </div>
  );
};

QuotesHeader.propTypes = {
  hideActionLink: PropTypes.bool
};
QuotesHeader.defaultProps = {
  hideActionLink: false
};

export default QuotesHeader;
